/**
 * 音响路由
 * */
export default [
  {
    path: "/handwritingIndex",
    name: "handwritingIndex",
    meta: {
      title: '首页'
    },
    component: () => import("@/views/handwritingSystem/index")
  },{
    path: '/handwritingSystemChannelList',
    name: 'handwritingSystemChannelList',
    component: () => import('@/views/handwritingSystem/deviceManage/channelList'),
    meta: {
      title: '渠道管理'
    }
  },{
    path: '/handwritingSystemMachineList',
    name: 'handwritingSystemMachineList',
    component: () => import('@/views/handwritingSystem/deviceManage/machineList'),
    meta: {
      title: '机型管理'
    }
  },{
    path: '/handwritingSystemDeviceList',
    name: 'handwritingSystemDeviceList',
    component: () => import('@/views/handwritingSystem/deviceManage/deviceList'),
    meta: {
      title: '设备管理'
    }
  },{
    path: '/handwritingSystemOtaManger',
    name: 'handwritingSystemOtaManger',
    component: () => import('@/views/handwritingSystem/apply/otaManger'),
    meta: {
      title: 'OTA管理'
    }
  },{
    path: '/handwritingSystemOtaDownloadLogs',
    name: 'handwritingSystemOtaDownloadLogs',
    component: () => import('@/views/handwritingSystem/apply/otaDownloadLogs'),
    meta: {
      title: 'OTA升级记录'
    }
  },{
    path: '/handwritingSystemImeiErrorLogList',
    name: 'handwritingSystemImeiErrorLogList',
    component: () => import('@/views/handwritingSystem/deviceManage/imeiErrorLogList'),
    meta: {
      title: '设备日志'
    }
  },{
    path: '/handwritingSystemAddModelPage',
    name: 'handwritingSystemAddModelPage',
    meta: {
      title: '新增机型'
    },
    component: () => import('@/views/handwritingSystem/deviceManage/addModelPage')
  },{
    path: '/handwritingSystemEditModelPage',
    name: 'handwritingSystemEditModelPage',
    meta: {
      title: '编辑机型'
    },
    component: () => import('@/views/handwritingSystem/deviceManage/editModelPage')
  },{
    path: '/handwritingDeviceMonthRegister',
    name: 'handwritingDeviceMonthRegister',
    meta: {
      title: '设备统计'
    },
    component: () => import('@/views/handwritingSystem/bi/deviceMonthRegister')
  },{
    path: '/handwritingSystemOtaUpdateAddPage',
    name: 'handwritingSystemOtaUpdateAddPage',
    meta: {
      title: 'OTA新增'
    },
    component: () => import('@/views/handwritingSystem/apply/otaUpdateAddPage')
  },{
    path: '/handwritingSystemOtaUpdateEditPage',
    name: 'handwritingSystemOtaUpdateEditPage',
    meta: {
      title: 'OTA编辑'
    },
    component: () => import('@/views/handwritingSystem/apply/otaUpdateEditPage')
  },{
    path: '/handwritingSystemDeviceQualityAssessment',
    name: 'handwritingSystemDeviceQualityAssessment',
    meta: {
      title: '智能检测'
    },
    component: () => import('@/views/handwritingSystem/deviceManage/deviceQualityAssessment')
  },{
    path: '/handwritingSystemDeviceLogView',
    name: 'handwritingSystemDeviceLogView',
    meta: {
      title: '设备日志'
    },
    component: () => import('@/views/handwritingSystem/baby/deviceLogView'),
  },{
    path: '/handwritingSystemSearchAppUse',
    name: 'handwritingSystemSearchAppUse',
    component: () => import('@/views/handwritingSystem/bi/searchAppUse'),
    meta: {
      title: '使用分析'
    },
  },{
    path: '/handwritingSystemChannelAppPage',
    name: 'handwritingSystemChannelAppPage',
    component: () => import('@/views/handwritingSystem/deviceManage/ChannelAppPage'),
    meta: {
      title: '渠道APP关系管理'
    },
  },{
    path: '/handwritingSystemOtaBiHome',
    name: 'handwritingSystemOtaBiHome',
    component: () => import('@/views/handwritingSystem/bi/otaBiHome'),
    meta: {
      title: 'OTA升级统计'
    },
  },{
    path: '/handwritingSystemCheckModel',
    name: 'handwritingSystemCheckModel',
    component: () => import('@/views/handwritingSystem/deviceManage/checkModel'),
    meta: {
      title: '查看机型'
    }
  },
  {
    path: '/handwritingKiDozApp',
    name: 'handwritingKiDozApp',
    component: () => import("@/views/handwritingSystem/bi/KiDozApp"),
    meta: {
      title: 'kiDozApp'
    }
  },
  {
    path: '/handwritingOtaRequestLog',
    name: 'handwritingOtaRequestLog',
    component: () => import("@/views/handwritingSystem/bi/otaRequestLog"),
    meta: {
      title: 'ota请求日志'
    }
  }, {
    path: '/handwritingVirtualSnBatchList',
    name: 'handwritingVirtualSnBatchList',
    component: () => import("@/views/handwritingSystem/deviceManage/virtualSnBatchList"),
    meta: {
      title: '授权批次'
    }
  }, {
    path: '/handwritingVirtualSnLicenseList',
    name: 'handwritingVirtualSnLicenseList',
    component: () => import("@/views/handwritingSystem/deviceManage/virtualSnLicenseList"),
    meta: {
      title: '授权许可'
    }
  }, {
    path: '/handwritingApkManager',
    name: 'handwritingApkManager',
    component: () => import("@/views/handwritingSystem/apply/apkManager"),
    meta: {
      title: 'APK管理'
    }
  },{
    path: '/handwritingApkUpdateAddPage',
    name: 'handwritingApkUpdateAddPage',
    meta: {
      title: 'Apk新增'
    },
    component: () => import('@/views/handwritingSystem/apply/apkUpdateAddPage')
  },{
    path: '/handwritingApkUpdateEditPage',
    name: 'handwritingApkUpdateEditPage',
    meta: {
      title: 'Apk编辑'
    },
    component: () => import('@/views/handwritingSystem/apply/apkUpdateEditPage')
  }, {
    path: '/handwritingAppManager',
    name: 'handwritingAppManager',
    component: () => import("@/views/handwritingSystem/apply/appManager"),
    meta: {
      title: 'APP管理'
    }
  },{
    path: '/handwritingAppUpdateEditPage',
    name: 'handwritingAppUpdateEditPage',
    meta: {
      title: 'App编辑'
    },
    component: () => import('@/views/handwritingSystem/apply/appUpdateEditPage')
  },{
    path: '/handwritingAppUpdateAddPage',
    name: 'handwritingAppUpdateAddPage',
    meta: {
      title: 'APP新增'
    },
    component: () => import('@/views/handwritingSystem/apply/appUpdateAddPage')
  },{
    path: '/handwritingDeviceInstruction',
    name: 'handwritingDeviceInstruction',
    component: () => import('@/views/handwritingSystem/deviceManage/deviceInstruction'),
    meta: {
      title: '设备指令'
    }
  },{
    path: '/handwritingUserList',
    name: 'handwritingUserList',
    component: () => import('@/views/handwritingSystem/baby/photoUserList'),
    meta: {
      title: '用户管理'
    }
  },{
    path: '/handwritingSystemDeviceNew',
    name: 'handwritingSystemDeviceNew',
    meta: {
      title: '设备管理(新)'
    },
    component: () => import('@/views/handwritingSystem/deviceManage/deviceNew')
  }
]



// WEBPACK FOOTER //
// ./src/router/handwritingRouter.js